import { render, staticRenderFns } from "./DataJabatan.vue?vue&type=template&id=9d224dae&scoped=true&lang=html&"
import script from "./DataJabatan.vue?vue&type=script&lang=js&"
export * from "./DataJabatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d224dae",
  null
  
)

export default component.exports